import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {NgbModal, NgbModalConfig} from '@ng-bootstrap/ng-bootstrap';
import {EchoService, LanguageService, SettingsService} from '@customcoding/shared';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	providers: [NgbModalConfig, NgbModal]
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {

	lang = new Subject<string>();
	title = 'dashboard-app';
	demo = false;

	currentLang;

	constructor(
		private pushService: EchoService,
		private settings: SettingsService,
		private ngbModalConfig: NgbModalConfig,
		private languageService: LanguageService
	) {
		this.setUpNGBConfigs();
	}

	ngOnInit(): void {
		this.demo = this.settings.get('BETA');

		this.languageService.currentLangChanged.subscribe((newLang:string ) => {
			this.currentLang = newLang;

		})

	}

	ngAfterViewInit() {
	}

	ngOnDestroy() {
		this.pushService.leavePushChannel();
	}

	private setUpNGBConfigs() {
		this.ngbModalConfig.scrollable = true;
	}

}
